import config from 'react-global-configuration';

import {
  setOperationStatus,
  userLogin,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  UI_OPERATION_STATUS_ERROR,
  userGetCurrent,
} from '@uncinc/react-drupal-core';

// Temporary.
// This is a workaround, because the current setup for making requests to /user/register doesn't work for us.
// This function is directly copied from React Drupal Core, with the following changes:
//
// React Drupal Core:
// ----------------------
// body: JSON.stringify({
//   mail: email,
//   name: username,
//   pass: password,
// }),
//
// Jellinek frontend:
// ----------------------
// body: JSON.stringify({
//   mail: [email],
//   name: [username],
//   pass: [password],
// }),
//
// For more information, see ticket on Monday: https://uncinc.monday.com/boards/3375006290/pulses/3676940925

export const userRegisterWithPassword = (email, password, fullName) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_REQUEST));
    const language = getState().getIn(['ui', 'language']);
    const API_URL = config.get('API_URL');
    fetch(`${API_URL}/user/register?_format=json`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        mail: {
          value: email,
        },
        name: {
          value: email,
        },
        pass: {
          value: password,
        },
        field_name: {
          value: fullName,
        },
        preferred_langcode: {
          value: language,
        },
      }),
    }).then((response) => {
      if (response.ok) return response.json();
      else throw new Error();
    }).then(() => {
      dispatch(userLogin(email, password));
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_SUCCESS));
    }).catch(() => {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_ERROR));
    });
  };
};

export const userRegisterWithHti = (name, mail) => {
  return (dispatch) => {
    const values = { name, mail };

    dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_REQUEST));
    const API_URL = config.get('API_URL');
    fetch(`${API_URL}/hti/register?_format=json`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }).then((response) => {
      if (response.ok) return response.json();
      else throw new Error();
    }).then(() => {
      dispatch(userGetCurrent());
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_SUCCESS));
    }).catch(() => {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_ERROR));
    });
  };
};

export const userLoginWithSso = () => {
  return (dispatch) => {
    dispatch(setOperationStatus('user', 'login_sso', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    fetch(`${API_URL}/oauth/generate-url`)
      .then((response) => {
        if (response.ok) return response.json();
        else throw new Error();
      })
      .then((response) => {
        dispatch(setOperationStatus('user', 'login_sso', UI_OPERATION_STATUS_SUCCESS));
        window.location.replace(response.redirect);
      })
      .catch(() => {
        dispatch(setOperationStatus('user', 'login_sso', UI_OPERATION_STATUS_ERROR));
      });
  };
};
